module.exports = __webpack_public_path__ + "img/white06_128.7278b46a.png";